export default {
  addNotifications({ commit }, value) {
    commit("setNotifications", value);
  },
  addNotification({ commit }, { notification, type }) {
    commit("setAddNotification", { notification, type });
  },
  removeNotification({ commit, state }, notification, type) {
    commit("setRemoveNotification", notification, type);
  },
  updateNotifications({ commit }, value) {
    commit("setUpdateNotifications", value);
  },

  isLoadedNotifications({ commit }) {
    commit("setIsNotificationLoaded", true);
  },

  addNotificationsCount({ commit }, value) {
    commit("setUnreadNotificationsCount", value);
  },

  async markAsRead({ commit, state, dispatch }, notification) {
    commit("setRemoveNotification", { notification, type: "unreadNotifications" });    
    await dispatch("fetchUnreadNotificationsCount");    
    state.readNotificationsCount++;    
    commit("setAddNotification", { notification, type: "readNotifications" });
  },

  clearNotifications({ commit }) {
    commit("setClearNotifications");
  },

  async fetchNotifications({ state, commit }, { limit = 10, offset = 0, read = false } = {}) {
    const params = new URLSearchParams();
    params.set("limit", limit);
    params.set("offset", offset);
    if (read !== undefined) {
      params.set("read", read);
    }

    try {
      const response = await fetch(`/api/notifications?${params}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if(response.status === 401 || response.status === 403) {
        authErrorHandler(response.status);
      }
      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response:", errorData);
        return { notifications: [], count: 0 };
      }

      const data = await response.json();
      const typeCommitted = read ? "setReadNotifications" : "setUnreadNotifications";
      commit(typeCommitted, data);   
      return { newNotifications: data.results, count: data.count };
    } catch (error) {
      console.error("Cannot get notifications:", error.message);
      return { notifications: [], count: 0 };
    }
  },

  async fetchUnreadNotificationsCount({ commit }) {
    try {
      const response = await fetch(`/api/notifications/unread`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        const data = await response.json();
        commit("setUnreadNotificationsCount", data.result);
      } else {
        const errorData = await response.json();
        console.error("Ошибка:", errorData.message);
      }
    } catch (error) {
      console.error("Cannot get notifications:", error.message);
    }
  },

  async markNotificationAsRead({ commit }, notificationId) {
    try {
      const response = await fetch(
        `/api/notifications/${notificationId}/read`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ read: true }),
        }
      );

      if (response.ok) {
        return true;
        // emit('markAsRead', notificationId);
      } else {
        const errorData = await response.json();
        return errorData.message;
      }
    } catch (error) {
      console.error("Cannot mark notification as read:", error.message);
      return error.message;
    }
  },

  async getUnreadNotifications({ commit }) {
    try {
      const response = await fetch('/api/notifications/unread');
      const data = await response.json();
      commit("setUnreadNotifications", data.results);
    } catch (error) {
      console.error('Error fetching unread notifications:', error);
    }
  },

  async setNextPagonationNotifications({ dispatch, state }, payload) {
    await dispatch("fetchNotifications", {
        limit: 10,
        offset: payload.read ? state.readNotifications.length : state.unreadNotifications.length,
        read: payload.read,
    });
  }
};
